module.exports = __webpack_public_path__ + "static/culture-cannot-play-second-fiddle-to-technology-158ca102fb649f1d0ccbf7e4bcaf3931.png";